import {Button, Grid} from '@mui/material';
import AurIcon, {IconNames} from '../../common/aur-icon/AurIcon';
import {Controller} from 'react-hook-form';
import {AddClientInfoInputKey} from '../../pages/user-management/models';
import {t} from 'i18next';
import {AurBulkSelect} from '../../common/aur-select/AurBulkSelect';
import {IClientFormOption} from '../../bulk-user-upload-module/models';

interface AurClientFormFieldsProps {
  control: any;
  roleOptionList?: IClientFormOption[];
  clientOptionList?: string[];
  projectPermissionOptionList?: IClientFormOption[];
  clientPermissionOptionList?: IClientFormOption[];
  workspaceOptionList?: IClientFormOption[];
  projectOptions?: IClientFormOption[];
  isValid: boolean;
  buttonLabel: string;
  clientVisible: boolean;
  buttonVisible: boolean;
  fieldSize: number;
  projectMaxLength?: number;
  permissionMaxLength?: number;
}

const AurBulkClientFormFields = (props: AurClientFormFieldsProps) => {
  const {
    control,
    roleOptionList,
    projectPermissionOptionList,
    clientPermissionOptionList,
    workspaceOptionList,
    projectOptions,
    isValid,
    buttonLabel,
    buttonVisible,
    fieldSize,
  } = props;
  return (
    <Grid
      container
      className="add-bulk-client-info-container clientform-container"
    >
      <Grid item sm={12} md={fieldSize} className="form-content">
        <Controller
          name={AddClientInfoInputKey.role}
          control={control}
          render={({field, fieldState}) => (
            <AurBulkSelect
              label={t('addEditTeamMember.form.role')}
              optionList={roleOptionList ?? []}
              field={field}
              fieldState={fieldState}
              idKey={'id'}
              nameKey={'name'}
            />
          )}
        />
      </Grid>

      <Grid item sm={12} md={12} className="form-content">
        <Controller
          name={AddClientInfoInputKey.clientPermissionGroup}
          control={control}
          render={({field, fieldState}) => (
            <AurBulkSelect
              label={t('addEditTeamMember.form.clientPermissionGroup')}
              optionList={clientPermissionOptionList ?? []}
              field={field}
              fieldState={fieldState}
              idKey={'id'}
              nameKey={'name'}
            />
          )}
        />
      </Grid>
      <Grid item sm={12} md={12} className="form-content">
        <Controller
          name={AddClientInfoInputKey.projects}
          control={control}
          render={({field, fieldState}) => (
            <AurBulkSelect
              label={t('addEditTeamMember.form.projects')}
              optionList={projectOptions ?? []}
              field={field}
              fieldState={fieldState}
              idKey={'id'}
              nameKey={'name'}
            />
          )}
        />
      </Grid>
      <Grid item sm={12} md={12} className="form-content">
        <Controller
          name={AddClientInfoInputKey.projectPermissionGroup}
          control={control}
          render={({field, fieldState}) => (
            <AurBulkSelect
              label={t('addEditTeamMember.form.projectPermissionGroup')}
              optionList={projectPermissionOptionList ?? []}
              field={field}
              fieldState={fieldState}
              idKey={'id'}
              nameKey={'name'}
            />
          )}
        />
      </Grid>
      <Grid item sm={12} md={12} className="form-content">
        <Controller
          name={AddClientInfoInputKey.workspace}
          control={control}
          render={({field, fieldState}) => (
            <AurBulkSelect
              label={t('addEditTeamMember.form.editWorkspaces')}
              optionList={workspaceOptionList ?? []}
              field={field}
              fieldState={fieldState}
              idKey={'id'}
              nameKey={'name'}
            />
          )}
        />
      </Grid>

      {buttonVisible && (
        <Grid item sm={12} md={12} className="text-right user-form">
          <Button
            className="button-continue typo-text buttonLarge_size submit-btn"
            type="submit"
            disabled={!isValid}
          >
            {' '}
            {buttonLabel} <AurIcon icon={IconNames.ChevronRight} />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default AurBulkClientFormFields;
